import { Search } from '@mui/icons-material'
import { Box, OutlinedInput } from '@mui/material'

type FilteringSearchBarProps = {
	dataSet?: string[][] | string[]
	onQuery: (matches?: number[]) => void
}

// displays a search bar that queries onChange and returns the values
// that match the query
export const FilteringSearchBar = (props: FilteringSearchBarProps) => {
	const handleQuery = (queryValue: string) => {
		if (queryValue === '' || !props.dataSet) {
			props.onQuery(undefined)
			return
		}
		const indexes: number[] = []
		props.dataSet.forEach((value, index) => {
			if (Array.isArray(value))
				for (const arrayEntity of value) {
					if (arrayEntity.toUpperCase().includes(queryValue.toUpperCase())) {
						indexes.push(index)
						break
					}
				}
			else
				if (value.toUpperCase().includes(queryValue.toUpperCase()))
					indexes.push(index)
		})
		props.onQuery(indexes)

	}

	return (
		<Box width="100%">
			<OutlinedInput
				fullWidth
				size="small"
				placeholder={"Search"}
				endAdornment={<Search />}
				onChange={(evt) => handleQuery(evt.target.value)}
			/>
		</Box>
	)
}
